<template>
  <div>
    <div class="d-flex flex-column">
      <label>{{ trans('subscription.classification_config.weight') }}</label>
      <input
        v-model="weightAmount"
        class="form-control"
        type="number"
        min="1"
      >
      <div class="d-flex flex-row-reverse">
        <button
          type="button"
          class="btn btn-primary"
          @click="save()"
        >
          {{ trans('core.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import toast from '@/services/toast'
export default {
  name: 'WeightEditView',
  props: {
    weight: {
      required: false,
      type: Number,
      default: null,
    },
    weightList: {
      required: true,
      type: Array,
    },
  },
  data () {
    return {
      weightAmount: 1,
    }
  },
  computed: {
    weights () {
      if (this.weight) {
        return this.weightList
          .filter(weight => weight !== this.weight)
          .map(weight => weight)
      }
      return this.weightList.map(weight => weight)
    },
  },
  mounted () {
    if (this.weight) {
      this.weightAmount = this.weight
    }
  },
  methods: {
    save () {
      if (!this.weights.includes(Number(this.weightAmount))) {
        this.$emit('Save', this.getWeight())
      } else {
        toast.error(Lang.trans('subscription.classification_config.group_modal.unique_weight'))
      }
    },
    getWeight () {
      if (this.weight) {
        return {
          oldWeight: this.weight,
          newWeight: Number(this.weightAmount),
        }
      }
      return { newWeight: Number(this.weightAmount) }
    },
  },
}
</script>
